import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  title: string;
  message: string;
  options: any[];
  mode: string;
  showLogout?: boolean;
}

@Component({
  selector: 'app-option-chooser',
  styleUrls: ['./optionChooser.component.scss'],
  templateUrl: './optionChooser.component.html',
  standalone: false
})
export class OptionChooserComponent {
  constructor(
    public dialogRef: MatDialogRef<OptionChooserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  handleChoose(optionValue) {
    this.dialogRef.close(optionValue);
  }
}
